import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { Actions, EffectsModule } from '@ngrx/effects';
import { GamedaySharedModule } from '../shared/shared.module';
import { MarketDrawerComponent } from './components/market-drawer/market-drawer.component';
import { MarketDrawerBodyComponent } from './components/market-drawer/market-drawer-body.component';
import { MarketDrawerHeaderComponent } from './components/market-drawer/market-drawer-header.component';
import { RadioItemComponent } from './components/items/radio-item.component';
import { MarketsComponent } from './components/sections/markets/markets.component';
import { USTComponent } from './components/sections/ust/ust.component';
import { MMDComponent } from './components/sections/mmd/mmd.component';
import { CalendarComponent } from './components/sections/calendar/calendar.component';
import { CalendarService } from './services/calendar.service';
import { MarketsService } from './services/markets.service';
import { MMDService } from './services/mmd.service';
import { TreasuriesService } from './services/treasuries.service';
import { reducerDef } from './state/reducer';
import { CalendarEffects } from './state/calendar/effects';
import { MarketsEffects } from './state/markets/effects';
import { MMDReadsEffects } from './state/mmd/effects';
import { MarketDrawerEffects } from './state/effects';
import { USTreasuriesEffects } from './state/us-treasuries/effects';
import { CalendarHeaderComponent } from './components/sections/calendar/header/calendar-header.component';
import { CalendarRowComponent } from './components/sections/calendar/calendar-row/calendar-row.component';
import { ValueTableComponent } from './components/sections/calendar/value-table/value-table.component';
import { EventComponent } from './components/sections/calendar/event/event.component';
import { MarketsHeaderComponent } from './components/sections/markets/header/markets-header.component';
import { MarketTickerComponent } from './components/sections/markets/market-ticker/market-ticker.component';
import { TreasuryTickerComponent } from './components/sections/ust/treasury-ticker/treasury-ticker.component';
import { MMDHeaderComponent } from './components/sections/mmd/header/mmd-header.component';
import { USTHeaderComponent } from './components/sections/ust/header/ust-header.component';
import { ChangePipe } from './pipes/change.pipe';

export const effectsModule = EffectsModule.forFeature([
  CalendarEffects,
  MarketsEffects,
  MarketDrawerEffects,
  MMDReadsEffects,
  USTreasuriesEffects,
]);

export const storeModule = StoreModule.forFeature('marketDrawer', reducerDef);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GamedaySharedModule,
    effectsModule,
    storeModule,
  ],
  declarations: [
    MarketDrawerComponent,
    MarketDrawerHeaderComponent,
    MarketDrawerBodyComponent,
    RadioItemComponent,
    MarketsComponent,
    USTComponent,
    MMDComponent,
    CalendarComponent,
    CalendarHeaderComponent,
    CalendarRowComponent,
    ValueTableComponent,
    EventComponent,
    MarketsHeaderComponent,
    MMDHeaderComponent,
    USTHeaderComponent,
    MarketTickerComponent,
    TreasuryTickerComponent,
    ChangePipe,
  ],
  exports: [MarketDrawerComponent],
  providers: [
    MarketsService,
    CalendarService,
    MMDService,
    TreasuriesService,
    Actions,
  ],
})
export class MarketDrawerModule {}
